// Version : 1.0.0
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** Member Photo Add Start ************************/
export const memberPhotoAdd = (verifyData: any) => {
	const data = {
		AddMemberPhotoToken: verifyData,
	};
	const url = `${API_URL}addMemberPhoto`;
	return makeApiCall(url, data);
};
/** ***************** Member Photo Add End ************************/
